// src/landing/components/GallerySection.js
export default function GallerySection() {
  return <section><h2>Gallery (준비 중)</h2></section>;
}
